import { SERVICES_CHECKLIST } from "../constants";
import socialImage4 from "../images/social/service.webp";
import { motion } from "framer-motion";

const ServicesCheckList = () => {
  const servicesList = SERVICES_CHECKLIST;

  return (
    <section id="service-checklist" className="bg-black text-white">
      <div className="container">
        <div className="services">
          <div className="d-flex flex-column section-header p-5">
            <h2 className="p-3 fw-bold">Exclusive Services</h2>
            <h5 classNamee="fw-medium">What we offer</h5>
          </div>

          <div className="row">
            <div className="col-md-12 col-lg-6 mb-2">
              <img
                src={socialImage4}
                alt="Social 4"
                className="img-fluid w-100 rounded"
                loading="lazy"
              />
            </div>
            <div className="col-md-12 col-lg-6 mb-2">
              <div className="p-2">
                <div className="card-body text-black">
                  {servicesList.map((item, index) => (
                    <motion.div
                      key={index}
                      className="mb-2"
                      initial={{ opacity: 0, y: 50 }} // Start with opacity 0 and below view
                      whileInView={{ opacity: 1, y: 0 }} // Fade in and move up when in view
                      transition={{ duration: 0.6, delay: index * 0.3 }} // Optional stagger with delay
                      viewport={{ once: true }} // Ensure it only runs once
                    >
                      <h6 className="fw-bold text-uppercase">{item.name}</h6>
                      <motion.div
                        className="card"
                        initial={{ opacity: 0, y: 50 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6, delay: index * 0.3 + 0.2 }}
                        viewport={{ once: true }}
                      >
                        <div className="card-body">
                          {item.services.map((service, idx) => (
                            <motion.div
                              key={idx}
                              initial={{ opacity: 0, y: 50 }}
                              whileInView={{ opacity: 1, y: 0 }}
                              transition={{ duration: 0.6, delay: idx * 0.2 }} // Stagger services
                              viewport={{ once: true }}
                            >
                              <span>
                                <span className="fw-bold">{service.title}</span>{" "}
                                - <br />
                                <p className="texts">{service.text}</p>
                              </span>
                            </motion.div>
                          ))}
                        </div>
                      </motion.div>
                    </motion.div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="dark-to-light-fade-out"></div>
    </section>
  );
};

export default ServicesCheckList;
